import { useTranslation } from 'next-i18next';
import React, { VFC } from 'react';

import { FilteredUsers } from '@/apis/aniftyBackend/creations/interface';
import MarketplaceCreatorCard from '@/components/MarketplaceCreatorCard.tsx';
import routes from '@/config/routes';
import getDisplayName2 from '@/utils/getDisplayName2';

import styles from './MarketplaceProfileItems.module.scss';

type Props = {
  profile: FilteredUsers;
};

const MarketplaceProfileItems: VFC<Props> = ({ profile }: Props) => {
  const { i18n } = useTranslation();
  const isCreator = profile.TypeID === 2;
  const creations = isCreator
    ? profile.Creation
    : profile.UserTokenV2.filter((token) => token.Quantity > 0);
  const creatorLink = profile.UserName
    ? routes.creatorDetail(profile.UserName)
    : routes.myPage(profile.UserID);
  return (
    <div className={styles.marketplaceItem}>
      <MarketplaceCreatorCard
        creatorName={getDisplayName2(profile, i18n.language)}
        creatorProfileImageUrl={profile.ProfilePicUrl}
        userID={profile.UserID}
        creations={creations}
        isCreator={isCreator}
        link={creatorLink}
      />
    </div>
  );
};

export default MarketplaceProfileItems;
